import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Customer } from '@app/utils/interfaces/customer.interface';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-customer-info-section',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatFormFieldModule, MatInputModule, MatButtonModule],
  templateUrl: './customer-info-section.component.html',
  styleUrl: './customer-info-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerInfoSectionComponent {
  public readonly customerInfo = input<Customer | null>();
  public readonly closeDialog = output<void>();
  public readonly isActive = computed(() => this.customerInfo()?.isActive);

  public onClose(): void {
    this.closeDialog.emit();
  }
}
